import { createSelector, Selector } from "reselect";
import { RootState } from "../../store";
import cloneDeep from "lodash.clonedeep";

export const magentoSelector: Selector<RootState, RootState["magento"]> = (state) => state.magento;

export const productsSelector = createSelector(magentoSelector, (magento) => cloneDeep([...magento.regProducts]));

export const colocatedProductsSelector = createSelector(magentoSelector, (magento) => cloneDeep([...magento.colocatedRegProducts]));
